import AppLink from "root/s360components/AppLink";
import {EXTERNAL_icons, S360_urls} from "root/s360components/constants/S360_constants";
import React, {Fragment, useEffect, useState} from "react";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {ADMIN_USER_TYPES} from "root/s360components/AdminUsersDashboard";
import ESchoolsDashboardLink from "root/s360components/ESchoolsDashboardLink";

/**
 *
 * @uses useAdminUsersDashboardContext
 * @param school_id
 * @param user_type
 * @param permissionFlags
 * @returns {JSX.Element}
 * @constructor
 */
const AdminGoogleLinks = ({ school_id, user_type, permissionFlags}) =>
{

    const shouldShowOnlineSafety = (onlineSafetyEnabled) =>
    {
        const ENABLED = 1;

        return +onlineSafetyEnabled === ENABLED;
    }

    const shouldShowESchools = (eSchoolsEnabled) =>
    {
        const ENABLED = 'Y';

        return eSchoolsEnabled === ENABLED;
    }

    const permissions =
        {
            [ADMIN_USER_TYPES.SCHOOL_ADMIN]:
                {
                    googleDrive: true,
                    googleEmail: true,
                    googleCalendar: true,
                    eSchools: shouldShowESchools(permissionFlags.eschools_admin),
                    onlineSafety: false,
                    discuss: false,
                    sites: false,
                    notes: false
                },
            [ADMIN_USER_TYPES.GOVERNOR]:
                {
                    googleDrive: true,
                    googleEmail: true,
                    googleCalendar: true,
                    eSchools: shouldShowESchools(permissionFlags.eschools_admin),
                    onlineSafety: false,
                    discuss: true,
                    sites: true,
                    notes: true
                },
            [ADMIN_USER_TYPES.TEACHER]:
                {
                    googleDrive: true,
                    googleEmail: true,
                    googleCalendar: true,
                    eSchools: shouldShowESchools(permissionFlags.eschools_admin),
                    onlineSafety: shouldShowOnlineSafety(permissionFlags.online_safety_audit_enabled),
                    discuss: false,
                    sites: false,
                    notes: false
                }
        };

    return (
        <div className='link-wrapper-external'>
                {permissions[user_type].googleEmail && <AppLink link={S360_urls.GMAIL_URL} target='_blank' title='Mail'
                         imageSrc={EXTERNAL_icons.GMAIL} height={'60px'} width={'67px'}/>}
                {permissions[user_type].googleDrive && <AppLink link={S360_urls.DRIVE_URL} target='_blank' title='Drive'
                         imageSrc={EXTERNAL_icons.DRIVE}/>}
                {permissions[user_type].googleCalendar && <AppLink link={S360_urls.CALENDAR_URL} target='_blank' title='Calendar'
                         imageSrc={EXTERNAL_icons.CALENDAR}/>}
                {permissions[user_type].eSchools && <ESchoolsDashboardLink school_id={school_id}/>}
                {permissions[user_type].onlineSafety && <AppLink link={S360_urls.ONLINE_SAFETY_URL} target='_blank' title='Online Safety'
                                                      imageSrc={EXTERNAL_icons.ONLINE_SAFETY}/>}
                {permissions[user_type].discuss && <AppLink link={S360_urls.DISCUSS} target='_blank' title='Discuss'
                         imageSrc={EXTERNAL_icons.DISCUSS} height={'67px'} width={'67px'}/>}
                {permissions[user_type].sites && <AppLink link={S360_urls.SITES} target='_blank' title='Sites'
                         imageSrc={EXTERNAL_icons.SITES} height={'67px'} width={'67px'}/>}
                {permissions[user_type].notes && <AppLink link={S360_urls.NOTES} target='_blank' title='Notes'
                         imageSrc={EXTERNAL_icons.NOTES} height={'67px'} width={'67px'}/>}
        </div>
    )
}

export default AdminGoogleLinks;